<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="8">
        <v-card dark class="in-tribune" elevation="8">
          <v-card-title>Присоединиться к трибуне</v-card-title>
          <v-card-subtitle>Введите название:</v-card-subtitle>
          <v-card-text>
            <v-text-field solo light v-model="tribuneName" placeholder='Пример: Презентация'></v-text-field>
          </v-card-text>
          <v-card-actions class="mt-n4">
            <v-spacer></v-spacer>
            <v-btn large color="#ec1946" @click="InTribune">
              Войти
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <template v-if="$store.getters.loadedUserSpeech && $store.getters.UserSpeeches.length > 0">
      <v-row justify="center" align="center">
        <v-col cols="8">
          <v-card dark class="create-tribune" elevation="8">
            <v-card-title>Создать трибуну</v-card-title>
            <v-card-subtitle>Введите название:</v-card-subtitle>
            <v-card-text>
              <v-text-field solo light v-model="newTribuneName" placeholder='Пример: Презентация'></v-text-field>
            </v-card-text>
            <v-card-subtitle class="mt-n8">Выберите речь для презентации:</v-card-subtitle>
            <v-card-text>
              <v-combobox
                solo
                light
                v-model="newTribuneSpeech"
                :items="getSpeechList"
                prepend-inner-icon="mdi-message-text"
                placeholder="Название речи"
              >
              </v-combobox>
            </v-card-text>
            <v-card-subtitle class="mt-n8">Назначьте дату:</v-card-subtitle>
            <v-card-text>
              <v-menu
                transition="scale-transition"
                offset-y
                max-width="300px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="newTribuneDate"
                    placeholder="21.12.2012"
                    solo
                    light
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker locale="ru" first-day-of-week="1" v-model="newTribuneDate" no-title scrollable full-width>
                </v-date-picker>
              </v-menu>
            </v-card-text>
            <v-card-subtitle class="mt-n8">И время:</v-card-subtitle>
            <v-card-text>
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                width="300px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="newTribuneTime"
                    placeholder="00:00"
                    solo
                    light
                    prepend-inner-icon="mdi-clock"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="newTribuneTime"
                  landscape
                  full-width
                  color="#ec1946"
                ></v-time-picker>
              </v-menu>
            </v-card-text>
            <v-card-subtitle class="mt-n8">Дайте ссылку на конференцию ZOOM:</v-card-subtitle>
            <v-card-text>
              <v-text-field solo light v-model="newTribuneZOOM" placeholder='ZOOM link'></v-text-field>
            </v-card-text>
            <v-card-actions class="mt-n4">
              <v-spacer></v-spacer>
              <v-btn large color="#1f51a4" @click="addNewTribune">
                Создать
              </v-btn>
            </v-card-actions>
            <v-snackbar v-model="activator.addTribune" color="success" :timeout="3000">Трибуна успешно добавлена</v-snackbar>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
export default {
  name: 'Tribune',
  data () {
    return {
      tribuneName: '',
      newTribuneName: '',
      newTribuneSpeech: '',
      newTribuneDate: '',
      newTribuneTime: '',
      newTribuneZOOM: '',
      activator: {
        addTribune: false
      }
    }
  },
  computed: {
    getSpeechList: ({ $store }) => {
      const us = $store.getters.UserSpeeches
      return us.map(speech => {
        return {
          text: speech.name,
          value: speech.id
        }
      })
    }
  },
  methods: {
    async addNewTribune () {
      const tribune = {
        publisher_speech: this.newTribuneSpeech.value,
        name: this.newTribuneName,
        start: this.newTribuneDate + 'T' + this.newTribuneTime + ':00.000Z',
        session: this.newTribuneZOOM
      }
      await this.$store.dispatch({
        type: 'addNewTribune',
        tribune: tribune
      })
      this.activator.addTribune = true
    },
    InTribune () {
      this.$router.push({
        name: 'TribuneRoom',
        params: {
          tribuneName: this.tribuneName
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/colors";
.in-tribune {
  background-color: $itmo-blue!important;
}
.create-tribune {
  background-color: $itmo-red!important;
}
</style>
